export const useDocumentShowFormattingStore = (documentId: string) => {
  const { revision } = useSubmittedDocumentStore(documentId);

  if (!revision) {
    throw new Error("Revision is not defined");
  }

  return useDocumentShowFormatting(documentId, revision.id)();
};
